<template>
  <el-upload
    v-loading="loading"
    class="re-el-upload-width-max"
    drag
    action
    accept=".xlsx"
    :before-upload="beforeAvatarUpload"
    :http-request="uploadRequest">
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
    <div class="el-upload__tip"
         slot="tip"
         style="margin-top: 0;">只能选择Microsoft Office Excel文件，且不超过2048kb
    </div>
    <div class="el-upload__tip"
         slot="tip"
         style="margin-top: 0;">Excel需要包含表头[模型ID, 产品ID, 产品别名]
    </div>
  </el-upload>
</template>

<script>
import Worker from '@/worker/read-xlsx.worker'

const worker = new Worker()
export default {
  components: {},
  data () {
    return {
      loading: false,
    }
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {
  },
  methods: {
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!')
      }
      return isLt2M
    },
    uploadRequest (obj) {
      this.loading = true
      this.$emit('change-file', obj.file)
      worker.postMessage({file: obj.file, options: {header: 1}})
      worker.onmessage = (event) => {
        // 处理数据
        this.handleExcelData(event.data)
        this.loading = false
      }
    },
    handleExcelData (rows) {
      let items = []
      let tableHeader = {
        model_id: {
          index: null,
          text: '模型ID',
        },
        id: {
          index: null,
          text: '产品ID',
        },
        alias: {
          index: null,
          text: '产品别名',
        },
      }
      try {
        rows.forEach((row, rowIndex) => {
          let item = {
            model_id: '',
            id: '',
            alias: '',
          }
          row.forEach((cell, cellIndex) => {
            if (rowIndex) {
              // 获得数据行前 检查表头是否存在
              if (rowIndex === 1) {
                for (let header of Object.values(tableHeader)) {
                  if (!Number.isInteger(header.index)) {
                    throw new Error(`找不到[${header.text}]表头`)
                  }
                }
              }
              // 表格的行数据获取
              for (let field in tableHeader) {
                if (tableHeader.hasOwnProperty(field)) {
                  // 根据字段的 index 获得相应的值
                  if (cellIndex === tableHeader[field].index) {
                    item[field] = cell
                  }
                }
              }
            } else {
              // 检查表头字段是否存在
              for (let header of Object.values(tableHeader)) {
                if (cell === header.text) {
                  header.index = cellIndex
                }
              }
            }
          })
          rowIndex && items.push(item)
        })
        this.$emit('change', items)
      } catch (e) {
        this.$alert(e.toString(), '提示', {type: 'error'})
        throw new Error(e)
      }
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.image-list {
  .image-drop-shadow {
    padding: 5px;
    border: solid 1px #EFEFEF;
  }

  a {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  a:hover img.image-drop-shadow {
    border: solid 1px #CCC;
    -moz-box-shadow: 1px 1px 5px #999;
    -webkit-box-shadow: 1px 1px 5px #999;
    box-shadow: 1px 1px 5px #999;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/img-flow-product/components/ImgFlowProductBatchReadExcel.vue